<template>
  <div>
    <!-- Mobile Filter Overlay -->
    <nav class="company-mobile-filters" :inert="!mobileFiltersOpen" :hidden="!mobileFiltersOpen"
         :class="{ active: mobileFiltersOpen }">
      <div class="modal">
        <div class="top-menu-icons">
          <button class="back-link" @click="toggleMobileFilters">

            <svg class="icon arrow" width="16" height="8" viewBox="0 0 16 8" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12.6123 4.74998H0V3.24998H12.6122L10.6431 1.08534L11.7526 0.0759583L14.8632 3.49532L15.3223 4.00001L14.8632 4.5047L11.7526 7.92405L10.6431 6.91468L12.6123 4.74998Z"
                    fill="currentColor"/>
            </svg>

            Filtre
          </button>

          <button class="style-label-underscore clear-filters" @click="clearFilters">
            Ryd filtre
          </button>
        </div>

        <div class="modal-tags">
          <div class="mobile-tags-wrapper">
            <h3 class="style-h3 mobile-tag-wrapper filter-headline">{{ dropdown }}</h3>
            <div
                v-for="tag in tags"
                :key="tag"
                class="mobile-tag-wrapper"
            >
              <label class="mobile-tag">
                <span>{{ tag }}</span>
                <input type="checkbox" :value="tag" v-model="selectedTags"/>
              </label>
            </div>
          </div>

          <div class="close-btn-wrapper">
            <button class="button-secondary close-btn total-results-mobile-btn" @click="toggleMobileFilters">
              Vis {{ selectedTags.length > 0 ? filteredCompanies.length : 'alle' }} resultater
            </button>
          </div>
        </div>
      </div>
    </nav>

    <main id="maincontent">
      <div class="company-page-hero container">
        <div class="container-narrow heading-wrapper">
          <h1 class="style-h1">{{ title }}</h1>
          <p v-if="manchet" class="lead style-subheading">{{ manchet }}</p>
        </div>
      </div>

      <div class="container-narrow global-component content-wrapper">
        <div class="filters-wrapper">

          <Dropdown
              v-model="selectedTags"
              :tags="tags"
              :dropdownLabel="dropdown"
          />

          <button class="button-secondary filter-btn" @click="toggleMobileFilters">
            <span class="filter-text">Filtre</span>
            <svg class="icon icon-filter" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                 fill="none">
              <path
                  d="M8.40156 2.39961L8.40156 6.39961H7.20156V4.99961L2.40156 4.99961V3.79961L7.20156 3.79961L7.20156 2.39961H8.40156ZM13.6016 3.79961V4.99961H9.60156V3.79961H13.6016ZM11.2016 5.99961V7.39961H13.6016V8.59961H11.2016V9.99961H10.0016V5.99961H11.2016ZM8.80156 7.39961V8.59961L2.40156 8.59961V7.39961L8.80156 7.39961ZM6.40156 9.59961L6.40156 13.5996L5.20156 13.5996V12.1996H2.40156V10.9996L5.20156 10.9996V9.59961H6.40156ZM13.6016 10.9996V12.1996H7.20156V10.9996H13.6016Z"
                  fill="currentColor"/>
            </svg>
          </button>

          <div class="search-bar">
            <label class="search-input-wrapper">
              <input
                  type="text"
                  class="style-small"
                  placeholder="Søg i listen"
                  v-model="search"
              />
              <button type="button" class="search-button" aria-label="Søg">
                <svg class="icon" width="18" height="18" viewBox="0 0 18 18" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z"
                      fill="currentColor"/>
                  </svg>
                </button>
            </label>
          </div>
        </div>

        <div class="results-count-wrapper">
          <p class="style-small results-count">Viser {{ filteredCompanies.length }} af {{ totalItems }} resultater</p>
          <span class="line"> | </span>
          <button class="style-label-underscore clear-filters-desktop" @click="clearFilters">
            Ryd filtre
          </button>
        </div>

        <div class="companies-wrapper">
          <div
              v-for="item in paginatedCompanies"
              :key="item.id"
              class="company-item"
              :data-title="item.companyName.toLowerCase()"
              :data-tags="item.companySubjectTags?.map(t => t.name).join(' ')"
          >
            <div class="tags-wrapper">
              <span
                  v-for="tag in item.companySubjectTags"
                  :key="tag"
                  class="tag style-caption"
              >
                {{ tag.toUpperCase() }}
              </span>
            </div>

            <h4 class="style-h4 company-name">{{ item.companyName }}</h4>

            <div class="company-info">
              <p v-if="item.address">{{ item.address }}</p>
              <p v-if="item.phoneNumber" >Tlf:
                <a :href="`tel:${item.phoneNumber}`"
                   :aria-label="`tel:${item.phoneNumber}`">
                   {{ item.phoneNumber }}
                </a>
              </p>
              <p v-if="item.mail">Mail:
                <a :href="`mailto:${item.mail}`"
                   :aria-label="`mailto:${item.mail}`">
                   {{ item.mail }}
                </a>
              </p>
              <p v-if="item.cvrNumber">CVR: {{ item.cvrNumber }}</p>
              <a v-if="item.website" class="company-url" :href="item.website.url" :title="item.website.name">
                {{ item.website.name }}
              </a>
            </div>

            <div v-if="item.departments.length" class="departments">
              <p class="departments-heading">Afdelinger</p>
              <div class="department-items-wrapper">
                <div
                    v-for="(department, idx) in item.departments"
                    :key="idx"
                    class="department-item"
                >
                  <p>{{ department.addressDept }}, {{ department.cityAndPostalCode }}</p>
                  <a v-if="department.phoneNumberDept"
                     :href="`tel:${department.phoneNumberDept}`" 
                     :aria-label="`tel:${department.phoneNumberDept}`"
                     >{{ department.phoneNumberDept}}
                  </a>
                  <a v-if="department.mailDept"
                     :href="`mailto:${department.mailDept}`"
                     :aria-label="`mailto:${department.mailDept}`"
                     >{{ department.mailDept }}
                  </a>
                </div>
              </div>
            </div>


            <div v-if="item.verdicts.length" class="verdict-links">
              <template v-for="(verdict, idx) in item.verdicts" :key="idx">
                <a
                    v-if="verdict.verdictDocument"
                    :href="verdict.verdictDocument"
                    :title="verdict.verdictDocumentTitle"
                    class="style-arrow-link style-single-line"
                >
                  <span>{{ verdict.verdictText }}</span>
                  <div class="arrow"></div>
                </a>
                <p v-else>{{ verdict.verdictText }}</p>
              </template>
            </div>

          </div>
        </div>

        <Pagination
            :totalPages="totalPages"
            :currentPage="currentPage"
            @update:currentPage="val => currentPage = val"
        />
      </div>
    </main>
  </div>
</template>

<script setup>
import {ref, computed, watch} from 'vue'
import Dropdown from '../components/dropdown.vue'
import Pagination from '../components/pagination.vue'

const props = defineProps({
  allItems: Array,
  tags: Array,
  title: String,
  manchet: String,
  dropdown: String,
  pageSize: {
    type: Number,
    default: 5
  }
})

const search = ref('')
const selectedTags = ref([])
const currentPage = ref(1)
const itemsPerPage = Number(props.pageSize) || 5
const mobileFiltersOpen = ref(false)
const totalItems = props.allItems.length

const indexedCompanies = computed(() => {
  return props.allItems.map(item => {
    const itemData = [
      item.companyName?.toLowerCase() ?? '',
      item.address,
      item.phoneNumber,
      item.mail,
      item.cvrNumber,
      item.website.name,
    ]

    // Departments
    const departmentsData = (item.departments || [])
      .map(item =>
        [
          item.addressDept,
          item.cityAndPostalCode,
          item.phoneNumberDept,
          item.mailDept
        ]
          .filter(Boolean)
          .join(' ')
      )
      .join(' ')

    const searchIndex = [...itemData, departmentsData]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()

    return {
      ...item,
      searchIndex
    }
  })
})

const filteredCompanies = computed(() => {
  return indexedCompanies.value.filter(item => {
    const searchMatch = item.searchIndex.includes(search.value.toLowerCase())

    const tags = item.companySubjectTags?.map(t => t) || []
    const tagMatch =
        selectedTags.value.length === 0 ||
        selectedTags.value.some(tag => tags.includes(tag))

    return searchMatch && tagMatch
  })
})

const totalPages = computed(() => Math.max(1, Math.ceil(filteredCompanies.value.length / itemsPerPage)))

const paginatedCompanies = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage
  return filteredCompanies.value.slice(start, start + itemsPerPage)
})

function toggleMobileFilters() {
  mobileFiltersOpen.value = !mobileFiltersOpen.value
}

function closeMobileFilters() {
  mobileFiltersOpen.value = false;
}

function clearFilters() {
  closeMobileFilters()
  search.value = ''
  selectedTags.value = []
  currentPage.value = 1
}

watch([search, selectedTags], async () => {
  currentPage.value = 1;
});

watch(filteredCompanies, (newItems) => {
  const maxPage = Math.max(1, Math.ceil(newItems.length / itemsPerPage))
  if (currentPage.value > maxPage) {
    currentPage.value = maxPage
  }
})

watch(currentPage, async () => {
  const filterWrapper = document.querySelector('.filters-wrapper');
  if (filterWrapper) {
    const offsetTop = filterWrapper.getBoundingClientRect().top + window.scrollY - 180;
    window.scrollTo({top: offsetTop, behavior: 'smooth'});
  }
});
</script>
